import eventListeners from './event-listeners';
import contenteditableFocus from '../injections/iframe-additives/webkit-workarounds/contenteditable-focus';
import addSpaceToLastEmptyElementNode from '../../content-editable/helpers/add-space-to-last-empty-element-node.js';

const blurListener = (liveDocument) => {
  eventListeners.add(liveDocument, 'blur', contenteditableFocus.pauseByEvent, true);
  eventListeners.add(liveDocument, 'blur', addSpaceToLastEmptyElementNode, true);
};

export default blurListener;
